import React from "react";

import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import { useDatasetMappedValue } from "hooks/useDatasetMappedValue";
import { DatasetDataInfo } from "models/dataset-models";
import { formatDatasetValue } from "utils/value-format-utils";

type DatasetDisplayValueProps = {
  dataset: DatasetDataInfo | undefined;
  data: InstantDoubleValue | null | undefined;
  loading: boolean;
  isData: boolean;
  truncateSize?: number;
};

const DatasetDisplayValue: React.FC<DatasetDisplayValueProps> = ({
  dataset,
  data,
  loading,
  isData,
  truncateSize,
}) => {
  if (loading || !dataset) {
    return (
      <span className="px-3 py-1">
        <i className="pi pi-spin pi-spinner" />
      </span>
    );
  }

  if (!isData) {
    return (
      <>
        <span className="font-bold">N/A</span>
        <span className="font-italic"> {dataset.unit}</span>
      </>
    );
  }

  if (dataset.stringValueMapper) {
    return (
      <MappedValue
        mapValue={data?.value}
        mapperId={dataset.stringValueMapper}
        truncateSize={truncateSize}
      />
    );
  }

  return (
    <>
      <span className="font-bold">{formatDatasetValue(dataset, data)}</span>
      <span className="font-italic"> {dataset.unit}</span>
    </>
  );
};

export default DatasetDisplayValue;

type MappedValueProps = {
  mapValue: number | undefined;
  mapperId: number;
  truncateSize?: number;
};

const MappedValue: React.FC<MappedValueProps> = ({ mapValue, mapperId, truncateSize = 10 }) => {
  const mappedValue = useDatasetMappedValue(mapValue, mapperId);
  if (!mappedValue) {
    return <span className="px-3 py-1">{mapValue}{" "}
    <i className="pi pi-info-circle" />
    </span>;
  }

  return (
    <span
      className="truncate-text-mapped-value"
      style={{
        maxWidth: `${truncateSize}ch`,
      }}
    >
      {mappedValue}
    </span>
  );
};
